import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { ChatBackground } from 'APP/main/components/ChatBackground/ChatBackground';

import styles from './MainInfoBlock.styles.m.css';

export const MainInfoBlock: FC = observer(() => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <ChatBackground />
      <InfoBlock
        className={styles.infoBlock}
        title={t('common_empty_state_title')}
        descriptions={[t('common_empty_state_subtitle')]}
        image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.channelCreation)}
        type={InfoBlockTypes.Chat}
      />
    </div>
  );
});
